export abstract class ResponseBase {
  uniqueMessageId!: string;
}
